import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const Filters = styled.div`
  display: flex;
  gap: 8px;
`;

export const SearchInputWrapper = styled.div`
  width: 280px;
  height: 48px;
`;

export const FilterButton = styled.button`
  height: 48px;
  padding: 0 24px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? '#556EE6' : '#EFF2F7')};
  background: ${({ active }) => (active ? 'rgba(85,110,230,.1)' : '#F8F8FB')};
  color: ${({ active }) => (active ? '#556EE6' : '#495057')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    border-color: #556ee6;
  }
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, minmax(120px, 1fr)) auto;
`;

export const HeaderCell = styled.div`
  height: 40px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-bottom: 2px solid #eff2f7;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, minmax(120px, 1fr)) auto;
`;

export const Cell = styled.div`
  height: 64px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eff2f7;
`;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SizeSelector = styled.div`
  select {
    height: 32px;
    padding: 0 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 13px;
    color: #495057;
    background: #fff;
    cursor: pointer;
  }
`;

export const PageControls = styled.div`
  display: flex;
  gap: 4px;
`;

export const PageButton = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid ${({ active }) => (active ? '#556ee6' : '#ced4da')};
  background: ${({ active }) => (active ? '#556ee6' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#495057')};
  font-size: 13px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    border-color: #556ee6;
    color: ${({ active }) => (active ? '#fff' : '#556ee6')};
  }
`;
